import {
  Divider,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import {InvalidApplication, ValidApplication} from 'ApplicationEntry/models/Application';
import React from 'react';
import ModularHost from 'Shared/components/ModularHost/ModularHost';
import ActionsMenu from 'Shared/components/PagedView/ActionsMenu';
import ToolbarHeader from 'Shared/components/Toolbar/ToolbarHeader';
import './AdditionalProperties.sass';
import {ProductRiderGroups, ProductsRidersPolicyType} from 'ApplicationEntry/models/ProductsRiders/Families';

type AdditionalPropertiesProps = {
  application: InvalidApplication | ValidApplication;
};

const AdditionalPropertiesSection = (props: AdditionalPropertiesProps) => {
  return (
    <div className="additional-properties-section__head">
      <ModularHost>
        <ToolbarHeader title="Additional Properties" />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Property</TableCell>
                <TableCell>Value</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Requirement Error</TableCell>
                <TableCell>{props.application.additionalProperties.requirementError.value}</TableCell>
                <TableCell>
                  <ActionsMenu>
                    <MenuItem
                      id="additional-properties-table-requirement-error-actions-edit"
                      key="additional-properties-requirement-error-edit"
                    >
                      Edit
                    </MenuItem>
                  </ActionsMenu>
                </TableCell>
              </TableRow>
              {props.application.planCodes.productType.value !== ProductRiderGroups[ProductsRidersPolicyType.Iwl] && (
                <TableRow>
                  <TableCell>Premium Waiver</TableCell>
                  <TableCell>{props.application.additionalProperties.premiumWaiver.value}</TableCell>
                  <TableCell>
                    <ActionsMenu>
                      <MenuItem
                        id="additional-properties-table-premium-waiver-actions-edit"
                        key="additional-properties-premium-waiver-edit"
                      >
                        Edit
                      </MenuItem>
                    </ActionsMenu>
                  </TableCell>
                </TableRow>
              )}
              {props.application.planCodes.productType.value !== ProductRiderGroups[ProductsRidersPolicyType.Iwl] && (
                <TableRow>
                  <TableCell>Strike LayOff</TableCell>
                  <TableCell>{props.application.additionalProperties.strikeLayOff.value}</TableCell>
                  <TableCell>
                    <ActionsMenu>
                      <MenuItem
                        id="additional-properties-table-strike-layoff-actions-edit"
                        key="additional-properties-strike-layoff-edit"
                      >
                        Edit
                      </MenuItem>
                    </ActionsMenu>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell>Applicant Occupational Class</TableCell>
                <TableCell>{props.application.additionalProperties.applicantOccupationalClass.value}</TableCell>
                <TableCell>
                  <ActionsMenu>
                    <MenuItem
                      id="additional-properties-table-applicant-occupational-class-actions-edit"
                      key="additional-properties-applicant-occupational-class-edit"
                    >
                      Edit
                    </MenuItem>
                  </ActionsMenu>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Applicant Spouse Occupational Class</TableCell>
                <TableCell>{props.application.additionalProperties.applicantSpouseOccupationalClass.value}</TableCell>
                <TableCell>
                  <ActionsMenu>
                    <MenuItem
                      id="additional-properties-table-applicant-spouse-occupational-class-actions-edit"
                      key="additional-properties-applicant-spouse-occupational-class-edit"
                    >
                      Edit
                    </MenuItem>
                  </ActionsMenu>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Accidental Death Benefit</TableCell>
                <TableCell>{props.application.additionalProperties.accidentalDeathBenefit.value}</TableCell>
                <TableCell>
                  <ActionsMenu>
                    <MenuItem
                      id="additional-properties-table-accidental-death-benefit-actions-edit"
                      key="additional-properties-accidental-death-benefit-edit"
                    >
                      Edit
                    </MenuItem>
                  </ActionsMenu>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>ADB Units</TableCell>
                <TableCell>{props.application.additionalProperties.adbUnits}</TableCell>
                <TableCell>
                  <ActionsMenu>
                    <MenuItem
                      id="additional-properties-table-accidental-death-benefit-units-actions-edit"
                      key="additional-properties-accidental-death-benefit-units-edit"
                    >
                      Edit
                    </MenuItem>
                  </ActionsMenu>
                </TableCell>
              </TableRow>
              {props.application.planCodes.productType.value ===
                ProductRiderGroups[ProductsRidersPolicyType.Disability] && (
                <TableRow>
                  <TableCell>Disability Accident Days</TableCell>
                  <TableCell>{props.application.additionalProperties.eliminationPeriod.value.substr(0, 3)}</TableCell>
                  <TableCell>
                    <ActionsMenu>
                      <MenuItem
                        id="additional-properties-table-disability-accident-days-actions-edit"
                        key="additional-properties-disability-accident-days-edit"
                      >
                        Edit
                      </MenuItem>
                    </ActionsMenu>
                  </TableCell>
                </TableRow>
              )}
              {props.application.planCodes.productType.value ===
                ProductRiderGroups[ProductsRidersPolicyType.Disability] && (
                <TableRow>
                  <TableCell>Disability Sick Days</TableCell>
                  <TableCell>{props.application.additionalProperties.eliminationPeriod.value.substr(3)}</TableCell>
                  <TableCell>
                    <ActionsMenu>
                      <MenuItem
                        id="additional-properties-table-disability-sick-days-actions-edit"
                        key="additional-properties-disability-sick-days-edit"
                      >
                        Edit
                      </MenuItem>
                    </ActionsMenu>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell>True Age</TableCell>
                <TableCell>{props.application.additionalProperties.trueAge}</TableCell>
                <TableCell>
                  <ActionsMenu>
                    <MenuItem
                      id="additional-properties-table-requirement-error-actions-edit"
                      key="additional-properties-true-age-edit"
                    >
                      Edit
                    </MenuItem>
                  </ActionsMenu>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>MIB Requested</TableCell>
                <TableCell>{props.application.additionalProperties.mib! ? 'True' : 'False'}</TableCell>
                <TableCell>
                  <ActionsMenu>
                    <MenuItem
                      id="additional-properties-table-requirement-error-actions-edit"
                      key="additional-properties-mib-edit"
                    >
                      Edit
                    </MenuItem>
                  </ActionsMenu>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </ModularHost>
      <Divider className="application-form__actions-divider" />
    </div>
  );
};

export default AdditionalPropertiesSection;
